




























































































import { appModule } from "@/store/modules/app";
// import { storePresensi } from "@/store/modules/presensi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import UnitAutoComplete from "@/components/UnitAutoComplete.vue";
import KelasAutoComplete from "@/components/KelasAutoComplete.vue";
import DataBed from "@/services/DataBed";
import { storeBed } from "@/store/modules/bed";
import { userModule } from "@/store/modules/user";
@Component({
  components: {
    UnitAutoComplete,
    KelasAutoComplete,
  },
})
export default class ModalAddKamar extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() unit!: object;
  // @Prop() item!: object;
  // @Prop() bulan: string;
  // jam = "jam";
  // validasi = [(v) => this.cek(v) || this.message()];
  // valid = [(v) => !!v || "*Alasan harus diisi"];
  msg = "";
  // unit = {};
  kelas = {};
  no = null;
  catatanBed = "";
  checkGabung = false;
  gabung = "0";
  disUnit = false;

  simpan() {
    if (this.checkGabung == true) {
      this.gabung = "1";
    } else {
      this.gabung = "0";
    }
    // alert(this.gabung);
    const dt = DataBed.postBed(
      this.unit["id"],
      this.no,
      this.kelas["id"],
      this.user["pegawai_id"],
      this.gabung,
      this.catatanBed
    );
    dt.then((dt) => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        appModule.NoticeDelay("Berhasil Menambahkan Kamar");
        // storeBed.actBedByUnit(this.unit["id"]);
        this.$emit("addBed", true);
        this.close();
      }
    });
  }
  setUnit(val) {
    this.unit = val;
  }
  setKelas(val) {
    this.kelas = val;
  }

  get user() {
    return userModule.user;
  }

  get akses() {
    return storeBed.akses;
  }

  @Watch("akses")
  valAkses(val) {
    if (val["unit_id"] == "*") {
      this.disUnit = false;
    } else {
      // this.disUnit = true;
    }
  }

  close() {
    this.unit = {};
    this.kelas = {};
    this.catatanBed = "";
    this.no = null;
    this.show = false;
  }

  message() {
    return this.msg;
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
